import { summerConstants } from "@data/constants/summerConstants"

export const setSummerChoice = (status, { decidedAt } = {}) => ({
    type: summerConstants.SET_SUMMER_CHOICE,
    status,
    decidedAt: decidedAt || new Date().toISOString(),
})

export const setSummerPauseDates = ({ startDate, endDate }) => ({
    type: summerConstants.SET_SUMMER_PAUSE_DATES,
    pauseDates: { startDate, endDate },
})

export const setSummerStageBooking = ({ week, paid }) => ({
    type: summerConstants.SET_SUMMER_STAGE_BOOKING,
    stageBooking: {
        week,
        status: paid ? "paid" : "booked",
        paidAt: paid ? new Date().toISOString() : null,
    },
})

export const resetSummerChoice = () => ({
    type: summerConstants.RESET_SUMMER_CHOICE,
})

export const markSummerCockpitViewed = () => ({
    type: summerConstants.MARK_SUMMER_COCKPIT_VIEWED,
})

// Pose (ou retire) une pause juin avancée dans le cockpit. `startDate` (ISO
// "YYYY-MM-DD") → pause juin avec `juneTransition = pause_early`. `startDate`
// null → restaure le défaut (continuation jusqu'au 30 juin, rien à persister).
export const setJunePause = (startDate) => ({
    type: summerConstants.SET_JUNE_PAUSE,
    junePauseStartDate: startDate ?? null,
})

export const setResumePreference = (value) => ({
    type: summerConstants.SET_RESUME_PREFERENCE,
    resumePreference: value,
})

// Pose le choix mensuel (juillet ou août). Si `coursesConfig` est fourni
// (uniquement quand choice === "summer_courses"), il remplace le config
// existant ; sinon le reducer conserve le config précédent.
export const setSummerMonthChoice = (month, choice, coursesConfig) => ({
    type: summerConstants.SET_SUMMER_MONTH_CHOICE,
    month,
    choice,
    coursesConfig,
})

// Modifie uniquement la config Cours d'été d'un mois — sans toucher au
// `choice`. No-op si le mois n'est pas en Cours d'été.
export const setSummerMonthCoursesConfig = (month, coursesConfig) => ({
    type: summerConstants.SET_SUMMER_MONTH_COURSES_CONFIG,
    month,
    coursesConfig,
})

// Date de reprise effective de l'abo (1er → 7 sept). La période entre
// le 1er septembre et cette date est implicitement une pause de
// transition (gérée côté backend lors de l'application de la trajectoire).
export const setSummerResumeDate = (resumeDate) => ({
    type: summerConstants.SET_SUMMER_RESUME_DATE,
    resumeDate,
})

// Offre choisie à la reprise (type + fréquence hebdo + engagement).
// `frequency` ignoré pour le type autonomy.
export const setSummerResumeOffer = ({ type, frequency, commitment }) => ({
    type: summerConstants.SET_SUMMER_RESUME_OFFER,
    resumeType: type,
    resumeFrequency: frequency,
    resumeCommitment: commitment,
})

// Patch complet pour le bloc rentrée (utilisé par le modal de config) :
// type + frequency + commitment + date + subjectIds en un dispatch.
export const setSummerResumeConfig = ({
    type,
    frequency,
    commitment,
    resumeDate,
    subjectIds,
} = {}) => ({
    type: summerConstants.SET_SUMMER_RESUME_CONFIG,
    resumeType: type,
    resumeFrequency: frequency,
    resumeCommitment: commitment,
    resumeDate,
    resumeSubjectIds: subjectIds,
})

// Marque la trajectoire comme confirmée côté state (decidedAt). Le push
// effectif vers le backend est dispatché via apiRequest +
// subscriptionService.confirmSummerChoice depuis le Cockpit.
export const confirmSummerChoices = () => ({
    type: summerConstants.CONFIRM_SUMMER_CHOICES,
})
